// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LRjM0-List_merchant{height:2.3333333333rem;box-sizing:border-box;margin-bottom:1.6666666667rem}.T4CaB-List_amount{display:flex;flex-direction:column;gap:.3333333333rem}.cqLGd-List_timer{margin-top:1.6666666667rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"merchant": "LRjM0-List_merchant",
	"amount": "T4CaB-List_amount",
	"timer": "cqLGd-List_timer"
};
export default ___CSS_LOADER_EXPORT___;
